// extracted by mini-css-extract-plugin
module.exports = {"summaryChartContainer":"SummaryContent__summaryChartContainer__K52dT"};